import { CLIENT, ENV } from "./init"

export default class Env {
  static _comment = "Information about the environment. @version 1.0.1 @author Naldo Duran<naldorck@gmail.com>"

  static clients = Object.values(CLIENT)
  static env = Object.values(ENV)

  static children_clients = [
    {
      client: CLIENT.LOGYTECH,
      children: CLIENT.SHIPERTO,
    },
  ]

  static defaults = {
    client: process.env.REACT_APP_CLIENT || CLIENT.ENTEL_PERU,
    env: process.env.REACT_APP_ENV || ENV.UAT,
  }
}
